import { render, staticRenderFns } from "./timeToCustomer.vue?vue&type=template&id=2a47833e&scoped=true"
import script from "./timeToCustomer.vue?vue&type=script&lang=js"
export * from "./timeToCustomer.vue?vue&type=script&lang=js"
import style0 from "./timeToCustomer.vue?vue&type=style&index=0&id=2a47833e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47833e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a47833e')) {
      api.createRecord('2a47833e', component.options)
    } else {
      api.reload('2a47833e', component.options)
    }
    module.hot.accept("./timeToCustomer.vue?vue&type=template&id=2a47833e&scoped=true", function () {
      api.rerender('2a47833e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/customerTimelinessManagement/component/timeToCustomer.vue"
export default component.exports